/**
 * Fire-and-forget GET on the ad click tracking endpoint.
 * Uses no-cors so the browser can follow the redirect to the advertiser
 * domain without exposing the response (avoids a CORS error in the console).
 */
export const trackAdClick = (trackingUrl: string) => {
  void fetch(trackingUrl, {
    method: 'GET',
    mode: 'no-cors',
    keepalive: true,
  }).catch((error) => {
    console.error('Erreur lors du tracking du clic:', error);
  });
};
